export default "__VITE_ASSET__DhX4OFIn__"